<template>
    <ErrorModal />
    <ImprintNavigationController v-if="useNewImprintFlow" />
    <StepNavigstion v-else />

    <div v-if="useMockData()">
        <StateDebugger/>
    </div>
</template>


<script>
import StepNavigstion from './components/StepNavigstion.vue';
import ImprintNavigationController from './features/imprint/ImprintNavigationController.vue';
import StateDebugger from "@/features/imprint/components/StateDebugger.vue";
import {useMockData} from "../public/mock-data/products";
export default {
    name: 'App',
    methods: {useMockData},

    components: {
        StepNavigstion,
        ImprintNavigationController,
        StateDebugger
    },

    data() {
        return {
            // 'steps' | 'tabs' type of imprint
            imprintVersion: 'tabs'
        };
    },

    computed: {
        useNewImprintFlow() {
            return this.imprintVersion === 'tabs';
        }
    },

    created() {
        const root = document.getElementById('section-image-with-text-c');
        if (root && root.dataset && root.dataset.imprintVersion) {
            this.imprintVersion = root.dataset.imprintVersion;
        }
    }
};
</script>

<style lang="scss">
// Global styles are imported in main.js via main.scss
// Component-specific styles should be in separate .scss files
</style>
